import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../hooks/store-hooks";
import { useNavigationService } from "../../../../../../use-cases/navigation";
import { useUIService } from "../../../../../../use-cases/ui";
import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  Dialog,
  Divider,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  useExtracoesService,
  useLayoutExtracaoService,
} from "../../../../../../use-cases/geo-veles";
import { Transition } from "../../../../../components";
import { opcoesExtensoes } from "../../../../../assets/helpers";
import {
  IExtensaoArquivo,
  ILayoutOption,
} from "../../../../../../application/models";
import { CreateLayoutForm } from "./create-layout-form";
import { EditLayoutForm } from "./edit-layout-form";
import { DeleteLayoutForm } from "./delete-layout-form";
import { theme } from "../../../../../styles";
import { columnValueToLabel } from "../../../../../../utils";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { CreateLayoutPadraoForm } from "./create-layout-padrao-form";

export const LayoutExtracao = () => {
  // State
  const { extracaoAberta } = useAppSelector((state) => state.extracoes);
  const { extensaoArquivoSelecionada, layouts, layoutSelecionado } =
    useAppSelector((state) => state.layoutExtracao);
  // Use State
  const [loading, setLoading] = useState<boolean>(true);
  // Service
  const { navigateTo } = useNavigationService();
  const { setAlert, changeTitleAndMetaDesc } = useUIService();
  const { downloadExtracao } = useExtracoesService();
  const {
    findLayouts,
    resetLayoutSelecionado,
    resetLayouts,
    setExtensaoArquivoSelecionada,
    resetExtensaoArquivoSelecionada,
    setLayoutSelecionado,
    setOpenDeleteLayout,
    setCreateLayoutFormOpen,
    setEditLayoutFormOpen,
    setEditLayoutFormFieldsColunas,
    setEditLayoutFormFieldsIdVelesGeoLayoutExtracao,
    setEditLayoutFormFieldsNome,
    setOpenCreateLayoutPadraoForm,
  } = useLayoutExtracaoService();
  // Functions
  const closePage = () => {
    navigateTo({
      route: "/geo-veles/extracoes",
    });
    resetLayoutSelecionado();
    resetLayouts();
    resetExtensaoArquivoSelecionada();
  };
  // Use Effect
  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    changeTitleAndMetaDesc({
      metaDesc: "Escolha de layouts para download de arquivos",
      title: "Veles_Geo - Layouts",
    });
  }, [changeTitleAndMetaDesc]);

  useEffect(() => {
    findLayouts();
  }, [findLayouts]);

  // useEffect(() => {
  //   resetLayoutSelecionado();
  // }, [resetLayoutSelecionado, layouts]);

  useEffect(() => {
    if (layoutSelecionado) {
      setLayoutSelecionado(layoutSelecionado);
    } else {
      resetLayoutSelecionado();
    }
  });

  useEffect(() => {
    if (!loading) {
      if (!extracaoAberta) {
        setAlert({
          message: "Selecione uma extração antes de escolher um layout",
          type: "error",
        });
        navigateTo({
          route: "/geo-veles/extracoes",
        });
      }
    }
  }, [extracaoAberta, loading, navigateTo, setAlert]);

  useEffect(() => {});

  return (
    <>
      {loading ? (
        <></>
      ) : (
        extracaoAberta && (
          <>
            <Dialog
              fullScreen
              open={true}
              onClose={closePage}
              TransitionComponent={Transition}
              disableEscapeKeyDown
            >
              <AppBar sx={{ position: "relative" }}>
                <Toolbar>
                  <Typography
                    sx={{ ml: 2, flex: 1 }}
                    variant="h6"
                    component="div"
                    textTransform={"uppercase"}
                  >
                    Download de extração
                  </Typography>
                  <Button autoFocus color="inherit" onClick={closePage}>
                    Fechar
                  </Button>
                </Toolbar>
              </AppBar>
              <Box p={3}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Autocomplete
                      isOptionEqualToValue={(option, value) =>
                        option.IdVelesGeoLayoutExtracao ===
                        value?.IdVelesGeoLayoutExtracao
                      }
                      getOptionLabel={(option) =>
                        `Nome: ${option.Nome} | Usuário: ${option.NomeUsuario} | ${option.LoginUsuario}`
                      }
                      renderInput={(props) => (
                        <TextField
                          {...props}
                          label="Digite ou clique para selecionar o layout"
                        />
                      )}
                      noOptionsText={"Nenhum layout disponível"}
                      options={layouts}
                      onChange={(
                        event: any,
                        newValue: ILayoutOption | null
                      ) => {
                        if (newValue) {
                          const findLayout = layouts.find(
                            (layout) =>
                              layout.IdVelesGeoLayoutExtracao ===
                              newValue.IdVelesGeoLayoutExtracao
                          );
                          if (findLayout) {
                            setLayoutSelecionado(findLayout);
                          }
                        } else {
                          resetLayoutSelecionado();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Autocomplete
                      options={opcoesExtensoes}
                      value={extensaoArquivoSelecionada}
                      renderInput={(props) => (
                        <TextField
                          {...props}
                          label="Digite ou clique para selecionar a extensão"
                        />
                      )}
                      onChange={(
                        event: any,
                        newValue: IExtensaoArquivo | null
                      ) => {
                        if (newValue) {
                          setExtensaoArquivoSelecionada(newValue);
                        } else {
                          resetExtensaoArquivoSelecionada();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container justifyContent="center" spacing={6}>
                      <Grid item>
                        <Button
                          endIcon={<AddIcon />}
                          onClick={() => setCreateLayoutFormOpen(true)}
                        >
                          Criar novo layout
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          disabled={!layoutSelecionado}
                          endIcon={<EditIcon />}
                          onClick={() => {
                            if (layoutSelecionado) {
                              setEditLayoutFormOpen(true);
                              setEditLayoutFormFieldsColunas(
                                layoutSelecionado.Colunas
                              );
                              setEditLayoutFormFieldsIdVelesGeoLayoutExtracao(
                                layoutSelecionado.IdVelesGeoLayoutExtracao
                              );
                              setEditLayoutFormFieldsNome(
                                layoutSelecionado.Nome
                              );
                            }
                          }}
                        >
                          Editar layout
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          disabled={!layoutSelecionado || layouts.length <= 1}
                          onClick={() => setOpenDeleteLayout(true)}
                          endIcon={<DeleteIcon />}
                        >
                          Excluir layout
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={() => setOpenCreateLayoutPadraoForm(true)}
                          endIcon={<NewReleasesIcon />}
                        >
                          Clonar layout padrão
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  {layoutSelecionado && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <Typography
                          variant="h6"
                          color="primary"
                          fontWeight="bold"
                          textTransform="uppercase"
                          textAlign="center"
                        >
                          Colunas do layout selecionado
                        </Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <Divider
                          variant="middle"
                          color={theme.palette.primary.main}
                        />
                      </Grid>
                      <Grid container spacing={2} m={2}>
                        {layoutSelecionado.Colunas.map((coluna, i) => (
                          <Grid item xs={3} key={i}>
                            <ListItem
                              sx={{
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                                padding: "8px",
                              }}
                            >
                              <ListItemIcon>
                                <LabelImportantIcon />
                              </ListItemIcon>
                              <ListItemText
                                primary={coluna.label}
                                secondary={`Nome original: ${columnValueToLabel(
                                  coluna.value
                                )}`}
                              />
                            </ListItem>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid item xs={10}>
                        <Divider
                          variant="middle"
                          color={theme.palette.primary.main}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      disabled={
                        !layoutSelecionado || !extensaoArquivoSelecionada
                      }
                      variant="contained"
                      type="submit"
                      onClick={() => {
                        downloadExtracao();
                      }}
                      sx={{
                        mt: 2,
                      }}
                    >
                      Baixar
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Dialog>
            {/* Formulário de criação de Layout */}
            <CreateLayoutForm />
            {/* Formulário de edição de Layout */}
            <EditLayoutForm />
            {/* Formulário de exclução do layout */}
            <DeleteLayoutForm />
            {/* Fornulário de criação de layout padrão */}
            <CreateLayoutPadraoForm />
          </>
        )
      )}
    </>
  );
};
